module.exports = __webpack_public_path__ + "img/add-member.aef2b75f.svg";